import { FC } from 'react';
import { PageContainer } from '@edikk-edikk/ui';
import footerLinksCss from '#srcCssModules/footer/footer-links.module.scss';
import { useBaseContext } from '#base/hooks/use-base-context';
import { FooterLink } from '#base/components/footer/links';

const FooterLinks: FC = () => {
  const { footerLinks } = useBaseContext();

  if (footerLinks.length === 0) {
    return null;
  }

  const footerLinkElementList = footerLinks.map((footerLink) => (
    <FooterLink key={footerLink.id} footerLink={footerLink} />
  ));
  return (
    <PageContainer>
      <div className={footerLinksCss.footerLinks}>
        {footerLinkElementList}
      </div>
    </PageContainer>
  );
};

export { FooterLinks };
